<template>
  <div class="dialog-qrcode-wrapper">
    <el-dialog
      title="设备二维码"
      :visible="visible"
      @open="onDialogOpen"
      @close="onDialogClose"
      width="85%"
      class="dialog-qrcode">

      <el-button
        type="danger"
        @click="downloadAllQrcodes">下载所有二维码</el-button>

      <el-tabs
        :stretch="true"
        :laze="true"
        type="border-card"
        @tab-click="onTabClick"
        ref="qrcodeTabs"
        v-model="qrcodeType">

        <el-tab-pane
          label="绑定二维码"
          name="bind" >
          <div class="qrcode-list">
            <div class="qrcode-item">
              <bind-qrcode-preview
                 id="bind"
                 title="扫码绑定设备"
                 :showing-dev="showingDev"
                 :url="getQrcodeUrl('bind', showingDev, true)"/>
              <el-button
                size="small"
                @click="downloadQrcode('bind', `${showingDev.sn}-绑定二维码`)">下载绑定二维码</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="购物车二维码" name="cart">
          <div class="qrcode-list">
            <div class="qrcode-item">
              <qrcode-preview
                id="cartB"
                background="#8800c8"
                :title="`设备号：${showingDev.sn}-B`"
                :url="getQrcodeUrl('cart', showingDev, 'b')" />
              <el-button
                size="small"
                @click="downloadQrcode('cartB', `${showingDev.sn}-购物车仅购买二维码`)">下载购物车仅购买二维码</el-button>
            </div>
            <div class="qrcode-item">
              <qrcode-preview
                id="cartBg"
                background="#8800c8"
                :title="`设备号：${showingDev.sn}-BG`"
                :url="getQrcodeUrl('cart', showingDev, 'bg')" />
              <el-button
                size="small"
                @click="downloadQrcode('cartBg', `${showingDev.sn}-购物车游戏+购买二维码`)">下载购物车游戏+购买二维码</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="单货架购买二维码" name="b">
          <el-button
            type="danger"
            class="btn-download"
            @click="downloadQrcodesByType('b')">下载所有购买二维码</el-button>

          <div class="qrcode-list">
            <div class="qrcode-item"
              v-for="channelRoad in channelRoads"
              :key="channelRoad">
              <qrcode-preview
                :id="`b-${channelRoad}`"
                :title="`设备号：${showingDev.sn}-${channelRoad}`"
                :url="getQrcodeUrl('single', showingDev, 'b', channelRoad)" />
              <el-button
                size="small"
                @click="downloadQrcode(`b-${channelRoad}`, `${showingDev.sn}-货架${channelRoad}购买二维码`)">下载“货架{{ channelRoad }}”二维码</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="单货架游戏二维码" name="g">
          <el-button
            type="danger"
            class="btn-download"
            @click="downloadQrcodesByType('g')">下载所有游戏二维码</el-button>

          <div class="qrcode-list">
            <div class="qrcode-item"
              v-for="channelRoad in channelRoads"
              :key="channelRoad">
              <qrcode-preview
                :id="`g-${channelRoad}`"
                background="#ea5413"
                :title="`设备号：${showingDev.sn}-${channelRoad}`"
                :url="getQrcodeUrl('single', showingDev, 'g', channelRoad)" />
              <el-button
                size="small"
                @click="downloadQrcode(`g-${channelRoad}`, `${showingDev.sn}-货架${channelRoad}游戏二维码`)">下载“货架{{ channelRoad }}”二维码</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="单货架购买+游戏二维码" name="bg">
          <el-button
            type="danger"
            class="btn-download"
            @click="downloadQrcodesByType('bg')">下载所有购买 + 游戏二维码</el-button>

          <div class="qrcode-list">
            <div class="qrcode-item"
              v-for="channelRoad in channelRoads"
              :key="channelRoad">
              <qrcode-preview
                :id="`bg-${channelRoad}`"
                background="#e4007f"
                :title="`设备号：${showingDev.sn}-${channelRoad}`"
                :url="getQrcodeUrl('single', showingDev, 'bg', channelRoad)" />
              <el-button
                size="small"
                @click="downloadQrcode(`bg-${channelRoad}`, `${showingDev.sn}-货架${channelRoad}游戏+购买二维码`)">下载“货架{{ channelRoad }}”二维码</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane
          label="关注二维码"
          name="sub"
          v-if="showingDev.userid != 888888 && showingDev.userid > 0 && hasRes('wechat_account_qrcode_index')"
          >
          <el-button
            @click="onWechatQrcodeAddClick"
            v-if="hasRes('wechat_account_qrcode_create')"
            type="danger">添加微信关注二维码</el-button>
          <div class="qrcode-list" v-if="subWechatQrcodeList.length > 0">
            <div class="qrcode-item"
              v-for="(subQrcode, index) in subWechatQrcodeList"
              :key="sub-qrcode-`${index}`">

              <el-tooltip placement="top">
                <div slot="content">
                  公众号：{{ subQrcode.account_name }}<br/>
                  公众号 App ID：{{ subQrcode.app_id }}<br/>
                  货架号：{{ subQrcode.channel_road }}<br/>
                  设备类型：{{ typesEnum[subQrcode.dev_type] }}<br/>
                  购买模式：{{ subQrcode.buy_mode }}<br/>
                  关注后动作：{{ subActionEnum[subQrcode.sub_action] }}<br/>
                  关注后动作参数：{{ subQrcode.sub_extend }}<br/>
                  场景：{{ subQrcode.scene_str }}<br/>
                  二维码链接：{{ subQrcode.url }}<br/>
                  过期时间：{{ subQrcode.expire_seconds }}<br/>
                  创建时间：{{ subQrcode.create_at | dateformat }}
                </div>

                <sub-qrcode-preview
                  background="#28AC38"
                  :id="`sub-${subQrcode.channel_road}`"
                  :title="subQrcode.channel_road === 0 ? `设备号：${showingDev.sn}` : `设备号：${showingDev.sn}-${subQrcode.channel_road}`"
                  :url="subQrcode.url" />
              </el-tooltip>

              <el-button
                @click="downloadQrcode(`sub-${subQrcode.channel_road}`, `关注二维码-${subQrcode.channel_road}`)">下载关注二维码</el-button>
            </div>
          </div>
          <div style="text-align: center; margin: 30px 0;" v-else>
            暂无二维码～～
          </div>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import saveAs from 'file-saver'
import JSZip from 'jszip'

import QrcodePreview from '@/components/QrcodePreview'
import SubQrcodePreview from '@/components/SubQrcodePreview'
import BindQrcodePreview from '@/components/BindQrcodePreview'

import wechatAccountApi from '@/api/wechatAccountApi'

import { mapGetters } from 'vuex'

export default {
  name: 'DialogQrcode',
  components: {
    QrcodePreview,
    SubQrcodePreview,
    BindQrcodePreview
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    showingDev: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      typesEnum: {
        'osm': '线上商城',
        'gpm': '扭蛋机',
        'vm': '自动贩卖机',
        'lpk': '口红机',
        'mc': '脉冲',
        'fdj': '福袋机',
        'gzj': '格子机',
        'undefine': '未知'
      },
      subActionEnum: {
        'not': '无动作',
        'coupon': '优惠券',
        'gift': '兑换券'
      },
      qrcodeType: 'b',

      qrcodeCount: 0,
      downloadCount: 0,

      subWechatQrcodeList: [
        // {
        //   'account_name': '没有',
        //   'app_id': 'wx_adsasd',
        //   'clientid': 'asds',
        //   'sn': 68008,
        //   'channel_road': 0,
        //   'dev_type': 'gpm',
        //   'buy_mode': 'b',
        //   'sub_action': 'coupon',
        //   'sub_extend': 39,
        //   'exchange_limit': '',
        //   'scene_str': 'aksdjalsdnelrnqwer',
        //   'url': 'https://wujianhui.com',
        //   'ticket': 'ticket',
        //   'expire_seconds': '86400',
        //   'create_at': '2020-07-30T08:11:35.232Z'
        // }
      ]
    }
  },
  computed: {
    channelRoads () {
      if (JSON.stringify(this.showingDev) === '{}' || this.showingDev.dev_details.length === 0) {
        return []
      }

      const data = []
      for (let i = 1; i <= this.showingDev.dev_details[0].goods_length; i++) {
        data.push(i)
      }
      return data
    },
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    onTabClick (tab) {
      switch (tab.name) {
        case 'bind': {
          // 绑定二维码
          break
        }

        case 'cart': {
          // 购物车二维码
          break
        }

        case 'buy': {
          // 购买二维码
          break
        }

        case 'game': {
          // 游戏二维码
          break
        }

        case 'buyGame': {
          // 购买 + 游戏 二维码
          break
        }

        case 'sub': {
          // 关注二维码
          this.getSubsQrcode()
          break
        }
      }
    },
    onWechatQrcodeAddClick () {
      this.getWechatAccount()
    },
    onDialogOpen () {
      this.qrcodeCount = this.showingDev.dev_details[0].goods_length * 3 + 3
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },

    async getSubsQrcode () {
      if (!this.hasRes('wechat_account_qrcode_index')) return

      try {
        const { rcode, msg, data } = await wechatAccountApi.listWechatQrcode({
          page: 1,
          pageSize: 500,
          filters: {
            sn: this.showingDev.sn
          }
        })
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }

        this.subWechatQrcodeList = data.list
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取关注二维码失败',
          type: 'error'
        })
      }
    },

    // 根据 二维码类型、设备信息、购买模式、货道获取二维码地址
    getQrcodeUrl (qrcodeType, dev, mode, channelRoad) {
      let url = ''
      if (qrcodeType === 'bind') {
        url = `https://m.eshouyun.com/bind?c=${dev.clientid}&s=${dev.sn}`
      } else if (qrcodeType === 'cart') {
        url = `https://pay.eshouyun.com/loading/${dev.sn}-mgp-${mode}`
      } else if (qrcodeType === 'single') {
        url = `https://pay.eshouyun.com/loading/${dev.sn}-sgp-${mode}-${channelRoad}`
      }
      return url
    },

    // 根据指定二维码类型下载所有货道的二维码
    async downloadQrcodesByType (qrcodeType) {
      const folders = []
      const qrcodeTypeMap = {
        'b': '购买',
        'g': '游戏',
        'bg': '购买+游戏'
      }
      const qrcodeTypeName = qrcodeTypeMap[qrcodeType]

      // 显示 loading page
      this.downloadCount = 0
      const loading = this.$loading({
        lock: true,
        text: `正在下载二维码，下载进度: 0% (${this.downloadCount}/${this.showingDev.dev_details[0].goods_length})`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      // 文件夹信息
      const folderFiles = []
      const folderName = `${this.showingDev.sn}${qrcodeTypeName}二维码`

      for (let i = 1; i <= this.showingDev.dev_details[0].goods_length; i++) {
        // 遍历所有货道，存放在同一个文件夹
        const road = i

        // 更新 loading 信息
        const percent = this.downloadCount === 0 ? 0 : parseInt(this.downloadCount * 100 / this.showingDev.dev_details[0].goods_length)
        loading.setText(`正在下载二维码，下载进度: ${percent}% (${this.downloadCount}/${this.showingDev.dev_details[0].goods_length})`)

        const filename = `${this.showingDev.sn}-货架${road}${qrcodeTypeName}二维码.png`
        const ele = document.getElementById(`${qrcodeType}-${road}`)
        try {
          const canvas = await html2canvas(ele, {
            scale: 4,
            logging: false,
            useCORS: true
          })
          folderFiles.push({
            name: filename,
            data: canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1]
          })
        } catch (err) {
          console.log(err)
        }
        this.downloadCount++
      }

      // 将文件夹追加到文件夹列表当中
      folders.push({
        name: folderName,
        files: folderFiles
      })

      if (folders.length > 0) {
        try {
          loading.setText(`正在下载二维码，下载进度: 99% (${this.downloadCount}/${this.showingDev.dev_details[0].goods_length})`)

          await this.zipImages(`${this.showingDev.sn}${qrcodeTypeName}二维码.zip`, [], folders)
          this.$nextTick(() => {
            loading.close()
          })
        } catch (err) {
          this.$nextTick(() => {
            loading.close()
          })
        }
      }
    },

    // 获取所有二维码图片
    async downloadAllQrcodes () {
      const folders = []
      const files = []

      // 所有二维码类型
      const qrcodeTypeMap = {
        'b': '购买',
        'g': '游戏',
        'bg': '购买+游戏'
      }
      const qrcodeTypes = ['b', 'g', 'bg']
      // const qrcodeTypes = ['b']

      // 显示 loading page
      this.downloadCount = 0
      const loading = this.$loading({
        lock: true,
        text: `正在下载二维码，下载进度: 0% (${this.downloadCount}/${this.qrcodeCount})`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      // 下载绑定二维码
      // 更换 tab，以便于能够转换成 canvas
      this.qrcodeType = 'bind'

      // 获取绑定二维码
      let filename = `${this.showingDev.sn}-绑定二维码.png`
      let ele = document.getElementById('bind')

      let err = true
      // 购物车页面只有一个二维码，页面还没有渲染完就关闭了，导致购物车二维码失败
      for (;err;) {
        try {
          const canvas = await html2canvas(ele, {
            scale: 4,
            logging: false,
            useCORS: true
          })

          // If canvas is invalid
          if (canvas.width === 0) {
            continue
          }

          files.push({
            name: filename,
            data: canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1]
          })
          this.downloadCount++

          err = false
        } catch (err) {
          console.log(err)
        }
      }

      let percent = this.downloadCount === 0 ? 0 : parseInt(this.downloadCount * 100 / this.qrcodeCount)
      loading.setText(`正在下载二维码，下载进度: ${percent}% (${this.downloadCount}/${this.qrcodeCount})`)

      // 下载购物车二维码
      // 更换 tab，以便于能够转换成 canvas
      this.qrcodeType = 'cart'

      // 获取购物车二维码
      filename = `${this.showingDev.sn}-购物车仅购买二维码.png`
      ele = document.getElementById('cartB')

      err = true
      // 购物车页面只有一个二维码，页面还没有渲染完就关闭了，导致购物车二维码失败
      for (;err;) {
        try {
          const canvas = await html2canvas(ele, {
            scale: 4,
            logging: false,
            useCORS: true
          })

          // If canvas is invalid
          if (canvas.width === 0) {
            continue
          }

          files.push({
            name: filename,
            data: canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1]
          })
          this.downloadCount++

          err = false
        } catch (err) {
          console.log(err)
        }
      }

      percent = this.downloadCount === 0 ? 0 : parseInt(this.downloadCount * 100 / this.qrcodeCount)
      loading.setText(`正在下载二维码，下载进度: ${percent}% (${this.downloadCount}/${this.qrcodeCount})`)

      // 下载购物车游戏+购买二维码
      filename = `${this.showingDev.sn}-购物车购买+游戏二维码.png`
      ele = document.getElementById('cartBg')

      err = true
      // 购物车页面只有一个二维码，页面还没有渲染完就关闭了，导致购物车二维码失败
      for (;err;) {
        try {
          const canvas = await html2canvas(ele, {
            scale: 4,
            logging: false,
            useCORS: true
          })

          // If canvas is invalid
          if (canvas.width === 0) {
            continue
          }

          files.push({
            name: filename,
            data: canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1]
          })
          this.downloadCount++

          err = false
        } catch (err) {
          console.log(err)
        }
      }

      percent = this.downloadCount === 0 ? 0 : parseInt(this.downloadCount * 100 / this.qrcodeCount)
      loading.setText(`正在下载二维码，下载进度: ${percent}% (${this.downloadCount}/${this.qrcodeCount})`)

      // 下载单货道所有类型的二维码
      for (let i = 0; i < qrcodeTypes.length; i++) {
        // 遍历所有单货道类型的二维码
        const qrcodeType = qrcodeTypes[i]
        const qrcodeTypeName = qrcodeTypeMap[qrcodeType]

        // 更换 tab，以便于能够转换成 canvas
        this.qrcodeType = qrcodeType

        // 文件夹信息
        const folderFiles = []
        const folderName = qrcodeTypeName + '二维码'

        for (let i = 1; i <= this.showingDev.dev_details[0].goods_length; i++) {
          // 遍历所有货道，存放在同一个文件夹
          const road = i

          // 更新 loading 信息
          const percent = this.downloadCount === 0 ? 0 : parseInt(this.downloadCount * 100 / this.qrcodeCount)
          loading.setText(`正在下载二维码，下载进度: ${percent}% (${this.downloadCount}/${this.qrcodeCount})`)

          const filename = `${this.showingDev.sn}-货架${road}${qrcodeTypeName}二维码.png`
          const ele = document.getElementById(`${qrcodeType}-${road}`)
          try {
            const canvas = await html2canvas(ele, {
              scale: 4,
              logging: false,
              useCORS: true
            })
            folderFiles.push({
              name: filename,
              data: canvas.toDataURL('image/jpeg', [0.0, 1.0]).split(',')[1]
            })
          } catch (err) {
            console.log(err)
          }
          this.downloadCount++
        }

        // 将文件夹追加到文件夹列表当中
        folders.push({
          name: folderName,
          files: folderFiles
        })
      }

      if (files.length > 0 || folders.length > 0) {
        try {
          loading.setText(`正在下载二维码，下载进度: 99% (${this.downloadCount}/${this.qrcodeCount})`)

          await this.zipImages(`${this.showingDev.sn}二维码.zip`, files, folders)
          this.$nextTick(() => {
            loading.close()
          })
        } catch (err) {
          this.$nextTick(() => {
            loading.close()
          })
        }
      }
    },

    // 下载压缩包
    /*

      files: [
        {
          name: 'file name',
          data: 'file data',
        }
      ]

      folders: [
        {
          name: 'file data',
          files: [file]
        }
      ]

    */
    async zipImages (zipName, files, folders) {
      let zip = new JSZip()

      // 遍历所有文件
      files.forEach(file => {
        zip.file(file.name, file.data, {base64: true})
      })

      // 遍历所有文件夹
      folders.forEach(folder => {
        const f = zip.folder(folder.name)
        folder.files.forEach(file => {
          f.file(file.name, file.data, {base64: true})
        })
      })

      // 压缩文件
      try {
        const content = await zip.generateAsync({type: 'blob'})
        saveAs(content, zipName)
      } catch (err) {
        console.log(err)
        return err
      }
    },

    // 下载文件
    saveFile (data, filename) {
      const saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      saveLink.href = data
      saveLink.download = filename
      var event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      saveLink.dispatchEvent(event)
    },

    // 下载二维码
    downloadQrcode (eleId, filename) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载二维码，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      window.scrollTo(0, 0)
      const ele = document.getElementById(eleId)
      ele.style.position = 'fixed'
      ele.style.left = 0
      ele.style.top = 0
      html2canvas(ele, {
        scale: 4,
        logging: true,
        useCORS: true,
        removeContainer: true
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png')
        this.saveFile(imgData, filename)

        ele.style.position = 'static'
        this.$nextTick(() => {
          loading.close()
        })
      }).catch(err => {
        console.log(err)
        this.$nextTick(() => {
          loading.close()
        })
      })
    },
    async getWechatAccount () {
      const loading = this.$loading({
        lock: true,
        text: `正在获取公众号信息，请稍等...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      // Get wechat account
      try {
        const { rcode, data } = await wechatAccountApi.getWechatAccountByUserId(this.showingDev.userid)
        if (rcode === 701) {
          this.$message({
            message: '当前设备所属商户没有公众号配置',
            type: 'error'
          })
          this.$nextTick(() => {
            loading.close()
          })
          return
        }

        this.$nextTick(() => {
          loading.close()
        })
        this.showingDev.appId = data['app_id']
        this.$emit('wechat-qrcode-add', this.showingDev)
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取商户公众号配置失败',
          type: 'error'
        })
        this.$nextTick(() => {
          loading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dialog-qrcode-wrapper {
  overflow: hidden;

  .dialog-qrcode {
    text-align: center;

    button {
      margin-bottom: 1rem;
    }
  }

  .el-tab-pane {
    text-align: right;

    .qrcode-list {
      text-align: center;
    }
    button {
      margin-bottom: 0;
    }
    .btn-download {
      margin: 0 1.4rem 0 0;
    }
  }

  .qrcode-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row wrap;

    .qrcode-item {
      margin: .6rem;

      button {
        width: 100%;
        margin-top: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogQrcode.vue